<script>
import LoadingComponent from 'frontend/ui/components/LoadingComponent.vue'

export default {
  name: 'EaSpinner',
  props: {
    withoutTimeout: { type: Boolean },
    matchParent: { type: Boolean },
    spinnerSize: { type: Number },
    waitMs: { type: Number, default: 150 },
    message: { type: String },
  },
  data() {
    return {
      visible: this.withoutTimeout ? true : false,
      visibilityTimeout: null,
    }
  },
  computed: {
    delay() {
      return window.env !== 'test' ? this.waitMs : 0
    },
    spinnerStyles() {
      return {
        '--spinner-size': `${
          !!this.spinnerSize || this.spinnerSize == 0 ? this.spinnerSize : 60
        }px`,
      }
    },
  },
  mounted() {
    if (this.withoutTimeout) {
      this.visible = true
    } else {
      this.visibilityTimeout = setTimeout(() => {
        this.visible = true
      }, this.delay)
    }
  },
  beforeUnmount() {
    if (this.visibilityTimeout) {
      clearTimeout(this.visibilityTimeout)
    }
  },
  components: { LoadingComponent },
}
</script>

<template lang="pug">
.spinner-wrapper(v-if="visible" :class="{ 'match-parent': matchParent }")
  .spinner-background
  .spinner-content.d-flex.flex-column.align-items-center(:style="spinnerStyles")
    loading-component.spinner
    .message.mt-2.text-muted.text-center(v-if="message") {{ message }}
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 3;

  &.match-parent {
    position: absolute;
    height: 100%;
    width: 100%;
  }
}

.spinner-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background: map.get(themeVariables.$colors, surface);
  opacity: 0.85;
  z-index: 9999;
}

.spinner-content {
  position: relative;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 15px;
}
</style>
